export default __webpack_public_path__ + "20c9eb7fed3f6b934eb26eee20d752cb.png";